
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M98.4 43.7l-.3.2-.6.2-.7.2h-.6l-.5-.1-.6-.2-.4-.2-.2-.1.2.8.5 1.5.6 1.5.8 1.6.9 1.4 1 1.2 1 .8.8.5.8.2h.8l.8-.1.5-.2.5-.2.2-.2L128 39.3V27.6z"}}),_c('path',{attrs:{"d":"M108.8 55.9l-8.8 4.9-1.4.7-12.2-26.1H68.5L43 82.3l.9-.1 1-.2 2.2-.3 2.4-.5 2.5-.5 2.4-.7 2.6-.8 2.5-.9 1.9-.6.8-.4.8-.4.6-.6.7-.7.4-.8 12.2-25.5 7.9 19.6-.1.1-6.5 3.3-5.9 2.9-5.3 2.4-4.9 2.1-4.8 1.7-4.7 1.6-4.5 1.3-4.6 1.1-4.4.9-4.2.7-3.9.6-3.5.3-3.2.2-2.6.2-2.3-.1-3.5-.4-2.4-.6-1.7-.7-1.4-.9-1.2-1.1-.8-1.3-.6-1.4-.1-1.6.1-2 .7-2.2 1.2-2.5 1.5-2.5 1.8-2.4 2.2-2.4 2.1-2.2 2.2-2 2.4-1.8 2.7-2.1 2.8-1.8 2.6-1.6 2.8-1.6 2.9-1.4 2.8-1.3 2.9-1.2 2.8-.9 2.6-.8 2.3-.5 2.1-.4 2.1-.1 2.2.2 1.2.2-.6-2.2L55 41l-.8-2.5-.7-1.6-.5-.8-.5-.5-.6-.4-.9-.3-1.4-.2-2 .1-2.5.3-2.9.6-3 .9-3.1 1.1-3 1.3-2.8 1.3-2.8 1.5-2.7 1.5L22 45l-2.8 2-2.9 2-2.5 2-2.2 1.8-1.9 1.9-2 2L6 58.8l-1.7 2.3-1.4 2.3-1.2 2.5-.9 2.5-.6 2.5-.2 2.4.2 2.7.5 2.7.7 2.8 1 2.6 1.1 2.4 1.3 2.1 1.6 2.1 1.8 1.9 1.9 1.6 2.1 1.4 2.3 1.2 2.7.9 3.2.9 3.5.7 3.6.3 3.5.1 3.4-.2 3-.2 2.9-.4 2.9-.5 2.9-.6 2.8-.7 2.6-.6 2.9-.9 2.9-.8 2.9-.9 2.9-1.1 3-1.1 2.9-1.2 3-1.2 3-1.5 3.2-1.5 1.8-1 2.4-1.3 3.3-1.7 3.6-2 7.1 17.5.2.6.3.5.4.4.5.4.6.3.5.2.7.2h17.1l-13-28 2.2-1.2 10.5-5.9 11.6-6.4V45l-9.8 5.6z"}})])
          )
        }
      }
    